export default {
    disclaimer: {
        label_default: "Reconheço e concordo que os itens que estou encomendando/recebendo são propriedade da empresa e serão utilizados para atividades relacionadas ao meu trabalho. Além disso, se o endereço fornecido estiver incorreto ou não confirmado e meu pedido não for entregue, a empresa incorrerá em taxas de reabastecimento.",
        errors: {
            required: "Clique em \"Reconhecer declaração\" para fazer o pedido"
        }
    },
    preferred_delivery_date: {
        "Preferred Delivery Date": "Data de entrega preferencial"
    },
    order_note: {
        label: "Nota do pedido",
        placeholder: "Nota para o aprovador deste pedido",
        errors: {
            required: "É necessário preencher uma nota de pedido."
        }
    },
    send_emails_to_oobo_orderer: {
        "OOBO": "Avise-me sobre as atualizações deste pedido."
    },
    info: {
        label: "Observação: Para garantir a entrega bem-sucedida dos seus itens, insira seu endereço completo, incluindo quaisquer instruções especiais. Verifique se o CEP e o número de telefone estão completos e corretos antes de enviar seu pedido. Após o envio, os dados não poderão ser alterados e os pedidos não poderão ser cancelados."
    },
    info_EGY: {
        label: "A entrega não está disponível em áreas rurais. Se o seu endereço estiver fora da área metropolitana, seu pedido será enviado para o escritório local da DXC. Você será responsável por retirar seu pedido no escritório assim que ele chegar. Você será notificado quando seu pedido estiver pronto para retirada. Se, por algum motivo, você não puder retirar seu pedido no escritório da DXC, abra um chamado de suporte antes de finalizar o pedido."
    },
    shipping_next_quarter_message: {
        label: "Os pedidos podem sofrer atrasos durante o processamento de final de trimestre. Seu pedido foi recebido e será processado o mais breve possível."
    },
    label: {
        "All orders in DXC Gear require manager approval": "Todos os pedidos em DXC Gear requerem aprovação do gerente."
    },
    label_user_approval_manager: {
        "Your approving manager is {user_approval_manager_email}": "Seu gerente de aprovação é {user_approval_manager_email}"
    }
}